import styled from "styled-components";

export const Aprendizado = styled.div`
  background-color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    padding: 43px;

    #sec-img {
      figure {
        width: 90%;
        margin: 50px auto;
      }

      img {
        width: 100%;
        margin-left: 15px;
      }
    }

    #sec-txt {
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 122%;
        text-transform: uppercase;
        color: var(--orange);
        margin-bottom: 10px;
      }

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 122%;
        color: var(--title);
        margin-bottom: 24px;
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 160%;
        color: var(--paragraph);
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      flex-direction: row;

      #sec-img {
        width: 50%;

        figure {
          width: 70%;
        }
      }
      #sec-txt {
        width: 50%;

        span {
          font-size: 16px;
          line-height: 140%;
        }

        h1 {
          font-size: 48px;
          line-height: 140%;
        }

        p {
          font-size: 16px;
          line-height: 160%;
        }
      }
    }
  }
`;
